<template lang="pug">
v-container( max-higth='500px' max-width='1200' )
  v-card( justify='center' max-higth='300px' max-width='1800')
    v-row
      v-col
        v-img(:src='Customers.logoUrl' max-height='200' max-width='300' align='center'  )
      v-spacer
      v-col(align='end')
        Boton_imprimir(nombre_de_impresion='Documento_de_orden_compra_proveedor')
    v-container#Documento_de_orden_compra_proveedor
      v-row
        v-col
          h1 Orden de compra Nº :
            span.grey--text.text--darken--4 {{Datos.numero_de_operacion}}
          h1(align='end')
            span.grey--text.text--darken--4 {{Datos.estado_del_documento=='esperando'?'Aún sin enviar': 'Aprobado'}}
      v-row(justify='center' align='center' )
        v-col
          p Proveedor : 
            span.grey--text.text--darken--4 {{Datos.proveedor ? Datos.proveedor.name : ''}}
          p Documento :          
            span.grey--text.text--darken--4 {{Datos.proveedor ? Datos.proveedor.document : ''}}
          p Correo Electrónico :
            span.grey--text.text--darken--4 {{Datos.proveedor ? Datos.proveedor.email : ''}}
          p Correo adicional :   
            span.grey--text.text--darken--4 {{Datos.correo_adicional}}
          p Teléfono :           
            span.grey--text.text--darken--4 {{Datos.proveedor ? Datos.proveedor.phone : ''}}
        v-col
          p Calidad :                
            span.grey--text.text--darken--4 {{Datos.calidad}}
          p Garantía :               
            span.grey--text.text--darken--4 {{Datos.garantia}}
          p Medio de pago :          
            span.grey--text.text--darken--4 {{Datos.medio_de_pago ? Datos.medio_de_pago.description : ''}}
          p Tipo de pago :           
            span.grey--text.text--darken--4 {{Datos.tipo_de_cambio}}
      v-row(justify='center' align='center' )
        v-col
          v-data-table(  :headers='headers' :items='Datos.items' item-key='key' align='center' hide-default-footer )
      v-row
        v-col 
          h2 Notas :
          P ¿Correctamente envalado? 
            span.grey--text.text--darken--4 {{Datos.envalaje == true? 'Si':'No' }}
          P ¿Incluye envío?          
            span.grey--text.text--darken--4 {{Datos.envio == true? 'Si':'No' }}
          p Observaciones :          
            span.grey--text.text--darken--4 {{Datos.Observaciones}}
          p Importante :
            span.grey--text.text--darken--2 {{terminos}}
          p Condiciones :
            span.grey--text.text--darken--2  {{condiciones}}
      v-row
        v-col(align='right')
        
          h2 Atentamente 
          p Autor de la cotización : 
            span.grey--text.text--darken--4 {{Datos.creado_por}}
          p Empresa : 
            span.grey--text.text--darken--4 {{Customers.name}}
</template>
<script>  
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data:()=>({
    headers:[
      { text:'Productos', value:'descripcion' },
      { text:'Codigo', value:'codigo'},
      { text:'Cantidad ', value:'cantidad' },
      { text:'IGV', value:'igv' },
      { text:'Unidad de medida', value:'nombre_unidad_de_medida' },
      { text:'Precio unitario', value:'precio_unitario' },
      { text:'Total', value:'total' }
    ],
  }),
 created(){
    this.Seleccionar_consumidor(this.$route.params.customerName).then(async()=>{
      this.Activar_db()  
      await this.Obtener_orden_de_compra(this.$route.params.idOrdenCompra)
    })
 },
 methods:{
    ...mapActions({
      Seleccionar_consumidor: 'Customers/setCustomer',
      Activar_db: 'Customers/getAllDocuments',
      Obtener_orden_de_compra: 'Ordenes_de_compra/get',
    })

 },
computed: {
    ...mapState({
       Datos: state=> state.Ordenes_de_compra.datos,
       Customers: state=> state.Customers.data,
      Ordenes_de_compra: state=> state.Ordenes_de_compra,

    }),
     ...mapGetters({
      Medio_de_pago_record: 'PaymentMethods/record',
      Moneda: 'Currency/record',
      registro_de_credenciales: 'Credenciales/registro',
    }),
    terminos(){
      if(!this.registro_de_credenciales)return
  const importante = this.registro_de_credenciales.filter(item=>item.slug == "terminos-y-condiciones-orden-compra")
      return importante.length > 0?importante[0].valores.filter(item=>item.descripcion == "importante")[0].valor : ""
    },
    condiciones(){
      if(!this.registro_de_credenciales)return
      const importante = this.registro_de_credenciales.filter(item=>item.slug == "terminos-y-condiciones-orden-compra")
      return importante.length > 0 ?importante[0].valores.filter(item=>item.descripcion == "condiciones")[0].valor : ""
    }
  },
   components:{
    Boton_imprimir:()=>import ('@/components/boton_imprimir')
  },
}
</script>
